module.exports = __webpack_public_path__ + "static/feature-toggl-api-070d83cdd476681b1d8b707cffe1b075.png";